import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import { EntityProps } from 'client/types'
import CommonContactUs from 'common/components/entities/ContactUs'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import React, { createContext, useContext } from 'react'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'
export { createContactUs } from 'src/shared/entities/contact-us/create-contact-us'

const ContactUsDescendantIdsContext = createContext([] as string[])

type ContactUsDescendantIdsProviderProps = {
  children: React.ReactElement
  entityId: EntityIdType
}

export const useContactUsDescendantIds = () =>
  useContext(ContactUsDescendantIdsContext)

function ContactUsDescendantIdsProvider({
  children,
  entityId,
}: ContactUsDescendantIdsProviderProps) {
  const descendantIds = usePage(page =>
    pageSelectors.getDescendantIds(page, entityId),
  ).concat([entityId])
  return (
    <ContactUsDescendantIdsContext.Provider value={descendantIds}>
      {children}
    </ContactUsDescendantIdsContext.Provider>
  )
}

function ContactUs({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<ContactUsInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <ContactUsDescendantIdsProvider entityId={entity.id}>
        <CommonContactUs
          padding={entity.padding}
          mobilePadding={entity.mobilePadding}
          id={entity.htmlAttrId}
          border={entity.border}
          mobileBorder={entity.mobileBorder}
          backgroundColor={entity.backgroundColor}
          mobileBackgroundColor={entity.mobileBackgroundColor}
          boxShadow={entity.boxShadow}
          mobileBoxShadow={entity.mobileBoxShadow}
        >
          <ChildrenEntities
            id={entity.id}
            childIds={entity.childIds}
            type={entity.type}
          />
        </CommonContactUs>
      </ContactUsDescendantIdsProvider>
    </BaseEntityNew>
  )
}

export default ContactUs
